export default __webpack_public_path__ + "static/media/demo_3.f722f9d8.webm";